import { DeleteOutlined, StopOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { INewsGetResponse } from 'shared/types/news.types';
import { FrequencyDatesBack } from 'shared/enums/news';
import style from './index.module.scss';

type TActionButtonsProps = {
  fromArchive: string | null;
  unarchiveNews: () => void;
  archiveNews: () => void;
  resetPublication: () => void;
  isResetLoading?: boolean;
  isUpdateLoading?: boolean;
  data?: INewsGetResponse;
};

const ActionButtons: FC<TActionButtonsProps> = ({
  archiveNews,
  fromArchive,
  unarchiveNews,
  resetPublication,
  isResetLoading,
  isUpdateLoading,
  data,
}) => {
  return (
    <div className={style['action-buttons']}>
      <>
        {fromArchive ? (
          <Button onClick={unarchiveNews} loading={isUpdateLoading}>
            <DeleteOutlined />
            Восстановить
          </Button>
        ) : (
          <>
            <Button onClick={archiveNews} loading={isUpdateLoading}>
              <DeleteOutlined />
              Удалить
            </Button>
            {data?.retry !== FrequencyDatesBack.NONE ? (
              <Button onClick={resetPublication} loading={isResetLoading}>
                Сбросить публикацию
              </Button>
            ) : null}
          </>
        )}
      </>
      <Link to={'/news'}>
        <Button>
          <StopOutlined />
          Отмена
        </Button>
      </Link>
    </div>
  );
};

export default ActionButtons;
